import { enableProdMode } from '@angular/core';

import { environment } from './environments/environment';

import "hammerjs";
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app.config';

if (environment.production) {
  enableProdMode();
}

// platformBrowserDynamic().bootstrapModule(AppModule, { ngZoneEventCoalescing: true })
bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
